import { Component, OnInit } from '@angular/core';
import {Product} from '../../../models/product';
import {ActivatedRoute} from '@angular/router';
import {ProductService} from '../../../services/product.service';

@Component({
  selector: 'app-product-tour-details',
  templateUrl: './product-tour-details.component.html',
  styleUrls: ['./product-tour-details.component.css']
})
export class ProductTourDetailsComponent implements OnInit {

  item: Product;
  image;
  sku: string;
  pcode: string;

  constructor(private route: ActivatedRoute, public productService: ProductService,) { }

  ngOnInit(): void {

    this.route.paramMap.subscribe(paramMap => {
      this.sku = paramMap.get('sku');
      this.pcode = paramMap.get('code');
      this.fetchProductsDetailes();

    });
  }

  fetchProductsDetailes() {
    return this.productService.getProductDetailsFull(this.sku).subscribe((product: any) => {
      this.item = product;

    });

  }

}
